<template>
  <div class="vx-row">
      <vx-card >
        <template slot="actions">
          <div class="flex">
            <vs-button @click="onClickCreateStaff" class="mr-4" color="primary" type="filled">Create User</vs-button>
          </div>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" id="users-list"
                    :data="users_list"  @sort="handleSort"  :sst="true" stripe
                    class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th width="20%" sort-key="name">NAME</vs-th>
              <vs-th width="10%" sort-key="email">EMAIL</vs-th>
              <vs-th width="10%" sort-key="contact_1">CONTACT</vs-th>
              <vs-th width="10%">LAST LOGGED IN</vs-th>
              <vs-th width="10%" class="text-center">STATUS</vs-th>
              <vs-th width="10%">ROLE</vs-th>
              <vs-th width="10%">EMAIL VERIFIED AT</vs-th>
              <vs-th width="10%">2FA</vs-th>
              <vs-th width="10%" v-can="'edit-user'">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr  :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>

                <vs-td :data="data[indextr].contact_1">
                  {{ data[indextr].contact_1 }}
                </vs-td>

                <vs-td :data="data[indextr].last_login_at">
                  {{__dateTimeFormatter(data[indextr].last_login_at)}}
                </vs-td>

                <vs-td>
                  <vs-chip transparent :color="data[indextr].is_active === 1? 'primary' : 'danger'">
                    {{ data[indextr].is_active ? 'Active' : 'Inactive' }}
                  </vs-chip>
                </vs-td>

                <vs-td>
                  {{ data[indextr].role ? data[indextr].role.name : 'N/A' }}
                </vs-td>

                <vs-td :data="data[indextr].email_verified_at">
                  {{__dateTimeFormatterToDate(data[indextr].email_verified_at)}}
                </vs-td>

                <vs-td>
                  <vs-chip v-if="data[indextr].is_google_2fa_enable" transparent color="dark">
                    Enabled
                  </vs-chip>
                </vs-td>

                <vs-td >
                  <div class="vx-row">
                    <vx-tooltip v-if="!data[indextr].email_verified_at" text="Resend Welcome Email" class="mr-2">
                      <vs-button @click="onClickResendEmail(data[indextr].email)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-mail"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="Delete" class="m2-2">
                      <vs-button @click="onClickDeleteUser(data[indextr].id)"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </vx-card>
      <CreateTenantStaffPopUp ref="createTenantStaffPopUp"/>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const UserRepository = RepositoryFactory.get('user')
const TenantRepository = RepositoryFactory.get('tenant')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateTenantStaffPopUp from "@/components/popups/tenants/staff-users/CreateTenantStaffPopUp.vue"

export default {
  name: 'AllUsersList',
  data () {
    return {
      users_list: [],
      id: '',
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
    }
  },
  components: {
    CreateTenantStaffPopUp
  },
  mounted() {
    this.id= this.$route.params.id
  },
  methods: {
    async refreshData () {
      await this.fetchUsersList()
    },
    async fetchUsersList() {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.getTenantUsersList(this.id, this.page, this.filterQuery, 10, this.sort)
        console.log(data)
        this.users_list =  data.data
        this.meta.per_page = data.per_page
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickResendEmail(email) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.resendTenantStaffUserWelcomeEmail(this.id, email)
        this.showSuccessMessage('Staff user welcome email send successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickDeleteUser(id) {
      await this.$vs.loading({
        container: '#users-list',
        scale: 0.50
      });
      try {
        const { data } = await TenantRepository.deleteTenantUser(this.id, id)
        this.showSuccessMessage('Staff user deleted successfully')
        this.fetchUsersList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#users-list > .con-vs-loading')
    },
    async onClickCreateStaff() {
      await this.$refs.createTenantStaffPopUp.openPopup()
    },
    filterQueryUpdate (){
      this.fetchUsersList()
    },

    handleChangePage(page) {
      this.page=page;
      this.fetchUsersList()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchUsersList()
      }

    }

  },
  watch : {
    page(){
      this.fetchUsersList()
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>

</style>
